/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../public/upgrade/feature/booking/booking.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '../../../../../public/upgrade/feature/booking/booking.service';
import * as import6 from '../../../../../public/upgrade/core/point-of-sale.service.service';
import * as import7 from '../../../../../public/upgrade/core/date.service';
import * as import8 from '../../../../../public/upgrade/core/mobile.service';
import * as import9 from '@angular/core/src/linker/view_type';
import * as import10 from '@angular/core/src/change_detection/constants';
import * as import11 from '@angular/core/src/linker/component_factory';
import * as import12 from '@angular/http/src/http';
import * as import13 from '@angular/router/src/router_state';
import * as import14 from '../../../../../public/upgrade/root/loading/loading-wheel.service';
import * as import15 from '@angular/core/src/zone/ng_zone';
import * as import16 from '../../../../../public/upgrade/root/ga/ga.service';
import * as import17 from '@ngx-translate/core/src/translate.service';
import * as import18 from '../../../../../public/upgrade/root/sidebar/sidebar.service';
import * as import19 from '../../../../../public/upgrade/core/company_a2.service';
import * as import20 from '../../../../../public/upgrade/core/geo_a2.service';
import * as import21 from 'ngx-cookie/src/cookie.service';
import * as import22 from '../../../../../public/upgrade/root/toast/notification.service';
import * as import23 from '../../../../../public/upgrade/core/session.service';
import * as import24 from '@ngx-translate/core/src/translate.pipe';
import * as import25 from '@angular/core/src/linker/view_container';
import * as import26 from '@angular/core/src/change_detection/change_detection_util';
import * as import27 from '../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import28 from '@angular/core/src/linker/template_ref';
import * as import29 from '@angular/common/src/directives/ng_if';
import * as import30 from '../../../../../public/upgrade/shared/pager/eva-pager.component';
import * as import31 from '../../shared/pager/eva-pager.component.ngfactory';
import * as import32 from '../../../../../public/upgrade/feature/booking/filter/booking-filter.component';
import * as import33 from './filter/booking-filter.component.ngfactory';
import * as import34 from '../../../../../public/upgrade/feature/booking/list/booking-list.component';
import * as import35 from './list/booking-list.component.ngfactory';
import * as import36 from 'ngx-cookie/src/cookie-options-provider';
import * as import37 from '@angular/router/src/router';
export class Wrapper_BookingComponent {
  /*private*/ _eventHandler:Function;
  context:import0.BookingComponent;
  /*private*/ _changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any,p8:any,p9:any,p10:any,p11:any,p12:any,p13:any,p14:any) {
    this._changed = false;
    this.context = new import0.BookingComponent(p0,p1,p2,p3,p4,p5,p6,p7,p8,p9,p10,p11,p12,p13,p14);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_BookingComponent_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_BookingComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.BookingComponent>;
  _BookingService_0_3:import5.BookingService;
  _PointOfSaleA2Service_0_4:import6.PointOfSaleA2Service;
  _DateService_0_5:import7.DateService;
  _MobileService_0_6:import8.MobileService;
  _BookingComponent_0_7:Wrapper_BookingComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_BookingComponent_Host0,renderType_BookingComponent_Host,import9.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'booking',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_BookingComponent0(this.viewUtils,this,0,this._el_0);
    this._BookingService_0_3 = new import5.BookingService(this.injectorGet(import12.Http,this.parentIndex));
    this._PointOfSaleA2Service_0_4 = new import6.PointOfSaleA2Service(this.injectorGet(import12.Http,this.parentIndex));
    this._DateService_0_5 = new import7.DateService();
    this._MobileService_0_6 = new import8.MobileService();
    this._BookingComponent_0_7 = new Wrapper_BookingComponent(this._BookingService_0_3,this.injectorGet(import13.ActivatedRoute,this.parentIndex),this.injectorGet(import14.LoadingWheelService,this.parentIndex),this.injectorGet(import15.NgZone,this.parentIndex),this.injectorGet(import16.GAService,this.parentIndex),this.injectorGet(import17.TranslateService,this.parentIndex),this._PointOfSaleA2Service_0_4,this._DateService_0_5,this.injectorGet(import18.SidebarService,this.parentIndex),this.injectorGet(import19.CompanyServiceA2,this.parentIndex),this.injectorGet(import20.GeoServiceA2,this.parentIndex),this.injectorGet(import21.CookieService,this.parentIndex),this._MobileService_0_6,this.injectorGet(import22.NotificationService,this.parentIndex),this.injectorGet(import23.SessionService,this.parentIndex));
    this.compView_0.create(this._BookingComponent_0_7.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import11.ComponentRef_<any>(0,this,this._el_0,this._BookingComponent_0_7.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import5.BookingService) && (0 === requestNodeIndex))) { return this._BookingService_0_3; }
    if (((token === import6.PointOfSaleA2Service) && (0 === requestNodeIndex))) { return this._PointOfSaleA2Service_0_4; }
    if (((token === import7.DateService) && (0 === requestNodeIndex))) { return this._DateService_0_5; }
    if (((token === import8.MobileService) && (0 === requestNodeIndex))) { return this._MobileService_0_6; }
    if (((token === import0.BookingComponent) && (0 === requestNodeIndex))) { return this._BookingComponent_0_7.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._BookingComponent_0_7.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._BookingComponent_0_7.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const BookingComponentNgFactory:import11.ComponentFactory<import0.BookingComponent> = new import11.ComponentFactory<import0.BookingComponent>('booking',View_BookingComponent_Host0,import0.BookingComponent);
const styles_BookingComponent:any[] = ([] as any[]);
class View_BookingComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  /*private*/ _expr_7:any;
  _pipe_translate_0:import24.TranslatePipe;
  /*private*/ _expr_9:any;
  _pipe_translate_1:import24.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import25.ViewContainer) {
    super(View_BookingComponent1,renderType_BookingComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_7 = import26.UNINITIALIZED;
    this._expr_9 = import26.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','booking-list-download -eva-3-mt-xlg'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'dsp-button',new import3.InlineArray8(8,'color','darken','loading','false','size','md','variation','ghost'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                    ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'i',new import3.InlineArray2(2,'class','eva-3-icon-download'),(null as any));
    this._text_5 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_6 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_2));
    this._pipe_translate_0 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_1 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6
    ]
    ),[disposable_0]);
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import26.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_7:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('common.LOADING')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_7,currVal_7))) {
      this.renderer.setElementProperty(this._el_2,'loading-text',currVal_7);
      this._expr_7 = currVal_7;
    }
    valUnwrapper.reset();
    const currVal_9:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('bookingList.DOWNLOAD')),'\n                                ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_9,currVal_9))) {
      this.renderer.setText(this._text_5,currVal_9);
      this._expr_9 = currVal_9;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.exportData()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_BookingComponent3 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  /*private*/ _expr_5:any;
  _pipe_translate_0:import24.TranslatePipe;
  _pipe_translate_1:import24.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import25.ViewContainer) {
    super(View_BookingComponent3,renderType_BookingComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_5 = import26.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'p',new import3.InlineArray2(2,'class',' -eva-3-tc-gray-1 -eva-3-icon-sm -eva-3-pb-sm no-result-title'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this._pipe_translate_0 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_1 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import26.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_5:any = import3.inlineInterpolate(2,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingList.EMPTY_STATE.NO_BOOKING')),'',valUnwrapper.unwrap(this._pipe_translate_1.transform(this.parentView.parentView.context.noBookingDays)),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_5,currVal_5))) {
      this.renderer.setText(this._text_3,currVal_5);
      this._expr_5 = currVal_5;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingComponent4 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_8:any;
  _pipe_translate_0:import24.TranslatePipe;
  /*private*/ _expr_10:any;
  _pipe_translate_1:import24.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import25.ViewContainer) {
    super(View_BookingComponent4,renderType_BookingComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_8 = import26.UNINITIALIZED;
    this._expr_10 = import26.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray4(4,'class','col -lg-12 -md-12 -sm-12','qadata','noResults'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'p',new import3.InlineArray2(2,'class',' -eva-3-tc-gray-1 -eva-3-icon-sm -eva-3-pb-sm no-result-btitle'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                                        ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_0,'p',new import3.InlineArray2(2,'class',' -eva-3-tc-gray-1 -eva-3-icon-xsm -eva-3-tc-gray-3 -eva-3-pb-md no-result-subtitle'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this._pipe_translate_0 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this._pipe_translate_1 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._text_7
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import26.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_8:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingList.EMPTY_STATE.SEARCH_NO_RESULT')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_8,currVal_8))) {
      this.renderer.setText(this._text_3,currVal_8);
      this._expr_8 = currVal_8;
    }
    valUnwrapper.reset();
    const currVal_10:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('bookingList.EMPTY_STATE.SEARCH_NO_RESULT_DESCRIPTION')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_10,currVal_10))) {
      this.renderer.setText(this._text_6,currVal_10);
      this._expr_10 = currVal_10;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_BookingComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _anchor_8:any;
  /*private*/ _vc_8:import25.ViewContainer;
  _TemplateRef_8_5:any;
  _NgIf_8_6:import27.Wrapper_NgIf;
  _text_9:any;
  _anchor_10:any;
  /*private*/ _vc_10:import25.ViewContainer;
  _TemplateRef_10_5:any;
  _NgIf_10_6:import27.Wrapper_NgIf;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import25.ViewContainer) {
    super(View_BookingComponent2,renderType_BookingComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','eva-row -eva-3-mb-xlg -eva-3-mt-xlg -eva-3-pt-xlg booking-list-empty-state'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','-lg-12 -md-12 -sm-12 center-aligned no-result'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'img',new import3.InlineArray4(4,'class','no-result-image','src','assets/noresults-image.png'),(null as any));
    this._text_5 = this.renderer.createText(this._el_2,'\n                                ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm '),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                                    ',(null as any));
    this._anchor_8 = this.renderer.createTemplateAnchor(this._el_6,(null as any));
    this._vc_8 = new import25.ViewContainer(8,6,this,this._anchor_8);
    this._TemplateRef_8_5 = new import28.TemplateRef_(this,8,this._anchor_8);
    this._NgIf_8_6 = new import27.Wrapper_NgIf(this._vc_8.vcRef,this._TemplateRef_8_5);
    this._text_9 = this.renderer.createText(this._el_6,'\n                                    ',(null as any));
    this._anchor_10 = this.renderer.createTemplateAnchor(this._el_6,(null as any));
    this._vc_10 = new import25.ViewContainer(10,6,this,this._anchor_10);
    this._TemplateRef_10_5 = new import28.TemplateRef_(this,10,this._anchor_10);
    this._NgIf_10_6 = new import27.Wrapper_NgIf(this._vc_10.vcRef,this._TemplateRef_10_5);
    this._text_11 = this.renderer.createText(this._el_6,'\n                                ',(null as any));
    this._text_12 = this.renderer.createText(this._el_2,'\n                            ',(null as any));
    this._text_13 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._anchor_8,
      this._text_9,
      this._anchor_10,
      this._text_11,
      this._text_12,
      this._text_13
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import28.TemplateRef) && (8 === requestNodeIndex))) { return this._TemplateRef_8_5; }
    if (((token === import29.NgIf) && (8 === requestNodeIndex))) { return this._NgIf_8_6.context; }
    if (((token === import28.TemplateRef) && (10 === requestNodeIndex))) { return this._TemplateRef_10_5; }
    if (((token === import29.NgIf) && (10 === requestNodeIndex))) { return this._NgIf_10_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_8_0_0:boolean = !this.parentView.context.emptyStateBooking;
    this._NgIf_8_6.check_ngIf(currVal_8_0_0,throwOnChange,false);
    this._NgIf_8_6.ngDoCheck(this,this._anchor_8,throwOnChange);
    const currVal_10_0_0:any = this.parentView.context.emptyStateBooking;
    this._NgIf_10_6.check_ngIf(currVal_10_0_0,throwOnChange,false);
    this._NgIf_10_6.ngDoCheck(this,this._anchor_10,throwOnChange);
    this._vc_8.detectChangesInNestedViews(throwOnChange);
    this._vc_10.detectChangesInNestedViews(throwOnChange);
  }
  destroyInternal():void {
    this._vc_8.destroyNestedViews();
    this._vc_10.destroyNestedViews();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 8)) { return new View_BookingComponent3(this.viewUtils,this,8,this._anchor_8,this._vc_8); }
    if ((nodeIndex == 10)) { return new View_BookingComponent4(this.viewUtils,this,10,this._anchor_10,this._vc_10); }
    return (null as any);
  }
}
class View_BookingComponent5 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _text_2:any;
  _el_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _el_19:any;
  compView_19:import1.AppView<import30.EvaPagerComponent>;
  _EvaPagerComponent_19_3:import31.Wrapper_EvaPagerComponent;
  _text_20:any;
  _text_21:any;
  _text_22:any;
  /*private*/ _expr_25:any;
  _pipe_translate_0:import24.TranslatePipe;
  /*private*/ _expr_27:any;
  _pipe_translate_1:import24.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import25.ViewContainer) {
    super(View_BookingComponent5,renderType_BookingComponent,import9.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_25 = import26.UNINITIALIZED;
    this._expr_27 = import26.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._text_2 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_3 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','-eva-3-mt-lg'),(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'\n                                ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_3,'div',new import3.InlineArray2(2,'class','booking-list-download-responsive -eva-3-mt-xlg'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'\n                                    ',(null as any));
    this._el_7 = import3.createRenderElement(this.renderer,this._el_5,'dsp-button',new import3.InlineArray8(6,'color','darken','size','md','variation','ghost'),(null as any));
    this._text_8 = this.renderer.createText(this._el_7,'\n                                        ',(null as any));
    this._el_9 = import3.createRenderElement(this.renderer,this._el_7,'i',new import3.InlineArray2(2,'class','eva-3-icon-download'),(null as any));
    this._text_10 = this.renderer.createText(this._el_7,'',(null as any));
    this._text_11 = this.renderer.createText(this._el_5,'\n                                ',(null as any));
    this._text_12 = this.renderer.createText(this._el_3,'\n                            ',(null as any));
    this._text_13 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._text_14 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mt-lg'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n                                ',(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,this._el_15,'div',new import3.InlineArray2(2,'class','-lg-12 -md-12 -sm-12 center-aligned'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'\n                                    ',(null as any));
    this._el_19 = import3.createRenderElement(this.renderer,this._el_17,'eva-pager',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_19 = new import31.View_EvaPagerComponent0(this.viewUtils,this,19,this._el_19);
    this._EvaPagerComponent_19_3 = new import31.Wrapper_EvaPagerComponent();
    this.compView_19.create(this._EvaPagerComponent_19_3.context);
    this._text_20 = this.renderer.createText(this._el_17,'\n                                ',(null as any));
    this._text_21 = this.renderer.createText(this._el_15,'\n                            ',(null as any));
    this._text_22 = this.renderer.createText(this._el_0,'\n\n                        ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_7,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_7));
    this._pipe_translate_0 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_1 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_19,new import3.InlineArray2(2,'pageChanged',(null as any)),this.eventHandler(this.handleEvent_19));
    this._EvaPagerComponent_19_3.subscribe(this,this.eventHandler(this.handleEvent_19),true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._text_11,
      this._text_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._el_19,
      this._text_20,
      this._text_21,
      this._text_22
    ]
    ),[
      disposable_0,
      disposable_1
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import30.EvaPagerComponent) && (19 === requestNodeIndex))) { return this._EvaPagerComponent_19_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import26.ValueUnwrapper();
    const currVal_19_0_0:any = this.parentView.context.spage;
    this._EvaPagerComponent_19_3.check_config(currVal_19_0_0,throwOnChange,false);
    this._EvaPagerComponent_19_3.ngDoCheck(this,this._el_19,throwOnChange);
    valUnwrapper.reset();
    const currVal_25:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('common.LOADING')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_25,currVal_25))) {
      this.renderer.setElementProperty(this._el_7,'loading-text',currVal_25);
      this._expr_25 = currVal_25;
    }
    valUnwrapper.reset();
    const currVal_27:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('bookingList.DOWNLOAD')),'\n                                    ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_27,currVal_27))) {
      this.renderer.setText(this._text_10,currVal_27);
      this._expr_27 = currVal_27;
    }
    this.compView_19.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_19.destroy();
    this._EvaPagerComponent_19_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_7(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.exportData()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_19(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'pageChanged')) {
      const pd_sub_0:any = ((<any>this.parentView.context.changePageCallback($event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
var renderType_BookingComponent:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,styles_BookingComponent,{});
export class View_BookingComponent0 extends import1.AppView<import0.BookingComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _text_19:any;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _el_23:any;
  _text_24:any;
  _el_25:any;
  _text_26:any;
  _text_27:any;
  _text_28:any;
  _text_29:any;
  _el_30:any;
  _text_31:any;
  _el_32:any;
  _text_33:any;
  _el_34:any;
  compView_34:import1.AppView<import32.BookingFilterComponent>;
  _DateService_34_3:import7.DateService;
  _GAService_34_4:import16.GAService;
  _BookingFilterComponent_34_5:import33.Wrapper_BookingFilterComponent;
  _text_35:any;
  _text_36:any;
  _text_37:any;
  _el_38:any;
  _text_39:any;
  _el_40:any;
  _text_41:any;
  _el_42:any;
  _text_43:any;
  _el_44:any;
  _text_45:any;
  _el_46:any;
  _text_47:any;
  _el_48:any;
  _text_49:any;
  _el_50:any;
  _text_51:any;
  _el_52:any;
  _text_53:any;
  _text_54:any;
  _text_55:any;
  _anchor_56:any;
  /*private*/ _vc_56:import25.ViewContainer;
  _TemplateRef_56_5:any;
  _NgIf_56_6:import27.Wrapper_NgIf;
  _text_57:any;
  _text_58:any;
  _el_59:any;
  _text_60:any;
  _el_61:any;
  compView_61:import1.AppView<import34.BookingListComponent>;
  _GAService_61_3:import16.GAService;
  _BookingService_61_4:import5.BookingService;
  _CookieService_61_5:import21.CookieService;
  _BookingListComponent_61_6:import35.Wrapper_BookingListComponent;
  _text_62:any;
  _text_63:any;
  _anchor_64:any;
  /*private*/ _vc_64:import25.ViewContainer;
  _TemplateRef_64_5:any;
  _NgIf_64_6:import27.Wrapper_NgIf;
  _text_65:any;
  _anchor_66:any;
  /*private*/ _vc_66:import25.ViewContainer;
  _TemplateRef_66_5:any;
  _NgIf_66_6:import27.Wrapper_NgIf;
  _text_67:any;
  _text_68:any;
  _el_69:any;
  _text_70:any;
  _el_71:any;
  _text_72:any;
  _el_73:any;
  _text_74:any;
  _el_75:any;
  _text_76:any;
  _text_77:any;
  _text_78:any;
  _el_79:any;
  _text_80:any;
  _el_81:any;
  _text_82:any;
  _el_83:any;
  _text_84:any;
  _el_85:any;
  _text_86:any;
  _el_87:any;
  _text_88:any;
  _text_89:any;
  _text_90:any;
  _text_91:any;
  _text_92:any;
  _text_93:any;
  _text_94:any;
  _text_95:any;
  _text_96:any;
  /*private*/ _expr_115:any;
  _pipe_translate_0:import24.TranslatePipe;
  /*private*/ _expr_117:any;
  _pipe_translate_1:import24.TranslatePipe;
  /*private*/ _expr_119:any;
  _pipe_translate_2:import24.TranslatePipe;
  /*private*/ _expr_121:any;
  _pipe_translate_3:import24.TranslatePipe;
  /*private*/ _expr_123:any;
  /*private*/ _expr_124:any;
  _pipe_translate_4:import24.TranslatePipe;
  /*private*/ _expr_126:any;
  _pipe_translate_5:import24.TranslatePipe;
  /*private*/ _expr_128:any;
  _pipe_translate_6:import24.TranslatePipe;
  /*private*/ _expr_130:any;
  /*private*/ _expr_131:any;
  _pipe_translate_7:import24.TranslatePipe;
  /*private*/ _expr_133:any;
  /*private*/ _expr_134:any;
  _pipe_translate_8:import24.TranslatePipe;
  /*private*/ _expr_136:any;
  _pipe_translate_9:import24.TranslatePipe;
  /*private*/ _expr_138:any;
  _pipe_translate_10:import24.TranslatePipe;
  /*private*/ _expr_140:any;
  _pipe_translate_11:import24.TranslatePipe;
  /*private*/ _expr_142:any;
  _pipe_translate_12:import24.TranslatePipe;
  _pipe_translate_13:import24.TranslatePipe;
  _pipe_translate_14:import24.TranslatePipe;
  /*private*/ _expr_146:any;
  _pipe_translate_15:import24.TranslatePipe;
  /*private*/ _expr_148:any;
  _pipe_translate_16:import24.TranslatePipe;
  _pipe_translate_17:import24.TranslatePipe;
  _pipe_translate_18:import24.TranslatePipe;
  /*private*/ _expr_152:any;
  _pipe_translate_19:import24.TranslatePipe;
  /*private*/ _expr_154:any;
  _pipe_translate_20:import24.TranslatePipe;
  _pipe_translate_21:import24.TranslatePipe;
  _pipe_translate_22:import24.TranslatePipe;
  /*private*/ _expr_158:any;
  _pipe_translate_23:import24.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_BookingComponent0,renderType_BookingComponent,import9.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import10.ChangeDetectorStatus.CheckAlways);
    this._expr_115 = import26.UNINITIALIZED;
    this._expr_117 = import26.UNINITIALIZED;
    this._expr_119 = import26.UNINITIALIZED;
    this._expr_121 = import26.UNINITIALIZED;
    this._expr_123 = import26.UNINITIALIZED;
    this._expr_124 = import26.UNINITIALIZED;
    this._expr_126 = import26.UNINITIALIZED;
    this._expr_128 = import26.UNINITIALIZED;
    this._expr_130 = import26.UNINITIALIZED;
    this._expr_131 = import26.UNINITIALIZED;
    this._expr_133 = import26.UNINITIALIZED;
    this._expr_134 = import26.UNINITIALIZED;
    this._expr_136 = import26.UNINITIALIZED;
    this._expr_138 = import26.UNINITIALIZED;
    this._expr_140 = import26.UNINITIALIZED;
    this._expr_142 = import26.UNINITIALIZED;
    this._expr_146 = import26.UNINITIALIZED;
    this._expr_148 = import26.UNINITIALIZED;
    this._expr_152 = import26.UNINITIALIZED;
    this._expr_154 = import26.UNINITIALIZED;
    this._expr_158 = import26.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import11.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-slide -up -start reset-styles'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','container-fluid whitesmoke-section'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-container'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','eva-grid booking-container'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','booking-container'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mt-lg booking-title-section'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'div',new import3.InlineArray2(2,'class','col -lg-10 -md-10 -sm-12 -eva-3-pl-xsm'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'\n                            ',(null as any));
    this._el_14 = import3.createRenderElement(this.renderer,this._el_12,'p',new import3.InlineArray2(2,'class','-h1'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'',(null as any));
    this._text_16 = this.renderer.createText(this._el_12,'\n                            ',(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,this._el_12,'p',new import3.InlineArray2(2,'class','-h6 -eva-3-tc-gray-2 -eva-3-mt-sm'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'',(null as any));
    this._text_19 = this.renderer.createText(this._el_12,'\n                        ',(null as any));
    this._text_20 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._el_21 = import3.createRenderElement(this.renderer,this._el_10,'div',new import3.InlineArray2(2,'class','col -lg-2 -md-2 -eva-3-mt-md'),(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'\n                            ',(null as any));
    this._el_23 = import3.createRenderElement(this.renderer,this._el_21,'dsp-button',new import3.InlineArray16(10,'class','-eva-3-fr','color','darken','loading','false','size','md','variation','ghost'),(null as any));
    this._text_24 = this.renderer.createText(this._el_23,'\n                                ',(null as any));
    this._el_25 = import3.createRenderElement(this.renderer,this._el_23,'i',new import3.InlineArray2(2,'class','eva-3-icon-play'),(null as any));
    this._text_26 = this.renderer.createText(this._el_23,'',(null as any));
    this._text_27 = this.renderer.createText(this._el_21,'\n                        ',(null as any));
    this._text_28 = this.renderer.createText(this._el_10,'\n                    ',(null as any));
    this._text_29 = this.renderer.createText(this._el_8,'\n\n                    ',(null as any));
    this._el_30 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_31 = this.renderer.createText(this._el_30,'\n                        ',(null as any));
    this._el_32 = import3.createRenderElement(this.renderer,this._el_30,'div',new import3.InlineArray2(2,'class','-eva-3-ml-md'),(null as any));
    this._text_33 = this.renderer.createText(this._el_32,'\n                            ',(null as any));
    this._el_34 = import3.createRenderElement(this.renderer,this._el_32,'booking-filter',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_34 = new import33.View_BookingFilterComponent0(this.viewUtils,this,34,this._el_34);
    this._DateService_34_3 = new import7.DateService();
    this._GAService_34_4 = new import16.GAService();
    this._BookingFilterComponent_34_5 = new import33.Wrapper_BookingFilterComponent(this._DateService_34_3,this.parentView.injectorGet(import23.SessionService,this.parentIndex),this._GAService_34_4,this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.compView_34.ref);
    this.compView_34.create(this._BookingFilterComponent_34_5.context);
    this._text_35 = this.renderer.createText(this._el_32,'\n                        ',(null as any));
    this._text_36 = this.renderer.createText(this._el_30,'\n                    ',(null as any));
    this._text_37 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_38 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mt-lg -eva-3-pl-xsm booking-list-container'),(null as any));
    this._text_39 = this.renderer.createText(this._el_38,'\n                        ',(null as any));
    this._el_40 = import3.createRenderElement(this.renderer,this._el_38,'div',new import3.InlineArray2(2,'class','eva-3-row booking-list-nav'),(null as any));
    this._text_41 = this.renderer.createText(this._el_40,'\n                            ',(null as any));
    this._el_42 = import3.createRenderElement(this.renderer,this._el_40,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12 -eva-3-mb-md -eva-3-mt-md'),(null as any));
    this._text_43 = this.renderer.createText(this._el_42,'\n                                ',(null as any));
    this._el_44 = import3.createRenderElement(this.renderer,this._el_42,'dsp-sub-navs',new import3.InlineArray8(6,'border-bottom','true','id','navs','type','transparent'),(null as any));
    this._text_45 = this.renderer.createText(this._el_44,'\n                                    ',(null as any));
    this._el_46 = import3.createRenderElement(this.renderer,this._el_44,'dsp-sub-nav',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_47 = this.renderer.createText(this._el_44,'\n                                    ',(null as any));
    this._el_48 = import3.createRenderElement(this.renderer,this._el_44,'dsp-sub-nav',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_49 = this.renderer.createText(this._el_44,'\n                                    ',(null as any));
    this._el_50 = import3.createRenderElement(this.renderer,this._el_44,'dsp-sub-nav',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_51 = this.renderer.createText(this._el_44,'\n                                    ',(null as any));
    this._el_52 = import3.createRenderElement(this.renderer,this._el_44,'dsp-sub-nav',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_53 = this.renderer.createText(this._el_44,'\n                                ',(null as any));
    this._text_54 = this.renderer.createText(this._el_42,'\n\n                            ',(null as any));
    this._text_55 = this.renderer.createText(this._el_40,'\n                            ',(null as any));
    this._anchor_56 = this.renderer.createTemplateAnchor(this._el_40,(null as any));
    this._vc_56 = new import25.ViewContainer(56,40,this,this._anchor_56);
    this._TemplateRef_56_5 = new import28.TemplateRef_(this,56,this._anchor_56);
    this._NgIf_56_6 = new import27.Wrapper_NgIf(this._vc_56.vcRef,this._TemplateRef_56_5);
    this._text_57 = this.renderer.createText(this._el_40,'\n                        ',(null as any));
    this._text_58 = this.renderer.createText(this._el_38,'\n                        ',(null as any));
    this._el_59 = import3.createRenderElement(this.renderer,this._el_38,'div',new import3.InlineArray2(2,'class','booking-list-cards'),(null as any));
    this._text_60 = this.renderer.createText(this._el_59,'\n                            ',(null as any));
    this._el_61 = import3.createRenderElement(this.renderer,this._el_59,'booking-list',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_61 = new import35.View_BookingListComponent0(this.viewUtils,this,61,this._el_61);
    this._GAService_61_3 = new import16.GAService();
    this._BookingService_61_4 = new import5.BookingService(this.parentView.injectorGet(import12.Http,this.parentIndex));
    this._CookieService_61_5 = new import21.CookieService(this.parentView.injectorGet(import36.CookieOptionsProvider,this.parentIndex));
    this._BookingListComponent_61_6 = new import35.Wrapper_BookingListComponent(this.parentView.injectorGet(import37.Router,this.parentIndex),this.parentView.injectorGet(import13.ActivatedRoute,this.parentIndex),this._GAService_61_3,this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.parentView.injectorGet(import8.MobileService,this.parentIndex),this._BookingService_61_4,this.parentView.injectorGet(import22.NotificationService,this.parentIndex),this.parentView.injectorGet(import23.SessionService,this.parentIndex),this._CookieService_61_5);
    this.compView_61.create(this._BookingListComponent_61_6.context);
    this._text_62 = this.renderer.createText(this._el_59,'\n                        ',(null as any));
    this._text_63 = this.renderer.createText(this._el_38,'\n\n                        ',(null as any));
    this._anchor_64 = this.renderer.createTemplateAnchor(this._el_38,(null as any));
    this._vc_64 = new import25.ViewContainer(64,38,this,this._anchor_64);
    this._TemplateRef_64_5 = new import28.TemplateRef_(this,64,this._anchor_64);
    this._NgIf_64_6 = new import27.Wrapper_NgIf(this._vc_64.vcRef,this._TemplateRef_64_5);
    this._text_65 = this.renderer.createText(this._el_38,'\n                        ',(null as any));
    this._anchor_66 = this.renderer.createTemplateAnchor(this._el_38,(null as any));
    this._vc_66 = new import25.ViewContainer(66,38,this,this._anchor_66);
    this._TemplateRef_66_5 = new import28.TemplateRef_(this,66,this._anchor_66);
    this._NgIf_66_6 = new import27.Wrapper_NgIf(this._vc_66.vcRef,this._TemplateRef_66_5);
    this._text_67 = this.renderer.createText(this._el_38,'\n                    ',(null as any));
    this._text_68 = this.renderer.createText(this._el_8,'\n\n                    ',(null as any));
    this._el_69 = import3.createRenderElement(this.renderer,this._el_8,'dsp-modal-coachmark',new import3.InlineArray4(4,'custom-size','true','id','bookingTour'),(null as any));
    this._text_70 = this.renderer.createText(this._el_69,'\n                        ',(null as any));
    this._el_71 = import3.createRenderElement(this.renderer,this._el_69,'dsp-modal-coachmark-content',new import3.InlineArray2(2,'image-url','assets/onboarding_autos.png'),(null as any));
    this._text_72 = this.renderer.createText(this._el_69,'\n                        ',(null as any));
    this._el_73 = import3.createRenderElement(this.renderer,this._el_69,'dsp-modal-coachmark-content',new import3.InlineArray2(2,'image-url','assets/new_tabs.png'),(null as any));
    this._text_74 = this.renderer.createText(this._el_69,'\n                        ',(null as any));
    this._el_75 = import3.createRenderElement(this.renderer,this._el_69,'dsp-modal-coachmark-content',new import3.InlineArray2(2,'image-url','assets/booking_download.png'),(null as any));
    this._text_76 = this.renderer.createText(this._el_69,'\n                    ',(null as any));
    this._text_77 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._text_78 = this.renderer.createText(this._el_6,'\n\n                ',(null as any));
    this._el_79 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','btn-booking booking-content'),(null as any));
    this._text_80 = this.renderer.createText(this._el_79,'\n                    ',(null as any));
    this._el_81 = import3.createRenderElement(this.renderer,this._el_79,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mt-lg search-booking-button'),(null as any));
    this._text_82 = this.renderer.createText(this._el_81,'\n                        ',(null as any));
    this._el_83 = import3.createRenderElement(this.renderer,this._el_81,'div',new import3.InlineArray2(2,'class','-lg-12 -md-12 -sm-12 booking-button'),(null as any));
    this._text_84 = this.renderer.createText(this._el_83,'\n                            ',(null as any));
    this._el_85 = import3.createRenderElement(this.renderer,this._el_83,'dsp-button',new import3.InlineArray8(6,'color','blue','size','md','variation','ghost'),(null as any));
    this._text_86 = this.renderer.createText(this._el_85,'\n                                ',(null as any));
    this._el_87 = import3.createRenderElement(this.renderer,this._el_85,'i',new import3.InlineArray2(2,'class','eva-3-icon-search'),(null as any));
    this._text_88 = this.renderer.createText(this._el_85,'',(null as any));
    this._text_89 = this.renderer.createText(this._el_83,'\n                        ',(null as any));
    this._text_90 = this.renderer.createText(this._el_81,'\n                    ',(null as any));
    this._text_91 = this.renderer.createText(this._el_79,'\n                ',(null as any));
    this._text_92 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_93 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_94 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_95 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_96 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._pipe_translate_0 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_23,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_23));
    this._pipe_translate_2 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_3 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_34,new import3.InlineArray8(8,'filter',(null as any),'pointsOfSale',(null as any),'autocompleteCompany',(null as any),'autocompleteCities',(null as any)),this.eventHandler(this.handleEvent_34));
    this._BookingFilterComponent_34_5.subscribe(this,this.eventHandler(this.handleEvent_34),true,true,true,true);
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_44,new import3.InlineArray2(2,'subNavSelected',(null as any)),this.eventHandler(this.handleEvent_44));
    this._pipe_translate_4 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_5 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_6 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_7 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    var disposable_3:Function = import3.subscribeToRenderElement(this,this._el_69,new import3.InlineArray4(4,'close',(null as any),'complete',(null as any)),this.eventHandler(this.handleEvent_69));
    this._pipe_translate_8 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_9 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_10 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    var disposable_4:Function = import3.subscribeToRenderElement(this,this._el_71,new import3.InlineArray2(2,'next',(null as any)),this.eventHandler(this.handleEvent_71));
    this._pipe_translate_11 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_12 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_13 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_14 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    var disposable_5:Function = import3.subscribeToRenderElement(this,this._el_73,new import3.InlineArray4(4,'prev',(null as any),'next',(null as any)),this.eventHandler(this.handleEvent_73));
    this._pipe_translate_15 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_16 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_17 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_18 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    var disposable_6:Function = import3.subscribeToRenderElement(this,this._el_75,new import3.InlineArray2(2,'prev',(null as any)),this.eventHandler(this.handleEvent_75));
    this._pipe_translate_19 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_20 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_21 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_22 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    var disposable_7:Function = import3.subscribeToRenderElement(this,this._el_85,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_85));
    this._pipe_translate_23 = new import24.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._text_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._el_23,
      this._text_24,
      this._el_25,
      this._text_26,
      this._text_27,
      this._text_28,
      this._text_29,
      this._el_30,
      this._text_31,
      this._el_32,
      this._text_33,
      this._el_34,
      this._text_35,
      this._text_36,
      this._text_37,
      this._el_38,
      this._text_39,
      this._el_40,
      this._text_41,
      this._el_42,
      this._text_43,
      this._el_44,
      this._text_45,
      this._el_46,
      this._text_47,
      this._el_48,
      this._text_49,
      this._el_50,
      this._text_51,
      this._el_52,
      this._text_53,
      this._text_54,
      this._text_55,
      this._anchor_56,
      this._text_57,
      this._text_58,
      this._el_59,
      this._text_60,
      this._el_61,
      this._text_62,
      this._text_63,
      this._anchor_64,
      this._text_65,
      this._anchor_66,
      this._text_67,
      this._text_68,
      this._el_69,
      this._text_70,
      this._el_71,
      this._text_72,
      this._el_73,
      this._text_74,
      this._el_75,
      this._text_76,
      this._text_77,
      this._text_78,
      this._el_79,
      this._text_80,
      this._el_81,
      this._text_82,
      this._el_83,
      this._text_84,
      this._el_85,
      this._text_86,
      this._el_87,
      this._text_88,
      this._text_89,
      this._text_90,
      this._text_91,
      this._text_92,
      this._text_93,
      this._text_94,
      this._text_95,
      this._text_96
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4,
      disposable_5,
      disposable_6,
      disposable_7
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import7.DateService) && (34 === requestNodeIndex))) { return this._DateService_34_3; }
    if (((token === import16.GAService) && (34 === requestNodeIndex))) { return this._GAService_34_4; }
    if (((token === import32.BookingFilterComponent) && (34 === requestNodeIndex))) { return this._BookingFilterComponent_34_5.context; }
    if (((token === import28.TemplateRef) && (56 === requestNodeIndex))) { return this._TemplateRef_56_5; }
    if (((token === import29.NgIf) && (56 === requestNodeIndex))) { return this._NgIf_56_6.context; }
    if (((token === import16.GAService) && (61 === requestNodeIndex))) { return this._GAService_61_3; }
    if (((token === import5.BookingService) && (61 === requestNodeIndex))) { return this._BookingService_61_4; }
    if (((token === import21.CookieService) && (61 === requestNodeIndex))) { return this._CookieService_61_5; }
    if (((token === import34.BookingListComponent) && (61 === requestNodeIndex))) { return this._BookingListComponent_61_6.context; }
    if (((token === import28.TemplateRef) && (64 === requestNodeIndex))) { return this._TemplateRef_64_5; }
    if (((token === import29.NgIf) && (64 === requestNodeIndex))) { return this._NgIf_64_6.context; }
    if (((token === import28.TemplateRef) && (66 === requestNodeIndex))) { return this._TemplateRef_66_5; }
    if (((token === import29.NgIf) && (66 === requestNodeIndex))) { return this._NgIf_66_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import26.ValueUnwrapper();
    const currVal_34_0_0:any = this.context.metadata;
    this._BookingFilterComponent_34_5.check_data(currVal_34_0_0,throwOnChange,false);
    const currVal_34_0_1:any = this.context.landing;
    this._BookingFilterComponent_34_5.check_landing(currVal_34_0_1,throwOnChange,false);
    this._BookingFilterComponent_34_5.ngDoCheck(this,this._el_34,throwOnChange);
    const currVal_56_0_0:any = this.context.hasBookings;
    this._NgIf_56_6.check_ngIf(currVal_56_0_0,throwOnChange,false);
    this._NgIf_56_6.ngDoCheck(this,this._anchor_56,throwOnChange);
    const currVal_61_0_0:any = this.context.showMarkRead;
    this._BookingListComponent_61_6.check_check(currVal_61_0_0,throwOnChange,false);
    const currVal_61_0_1:any = ((this.context.spage == null)? (null as any): this.context.spage.items);
    this._BookingListComponent_61_6.check_list(currVal_61_0_1,throwOnChange,false);
    this._BookingListComponent_61_6.ngDoCheck(this,this._el_61,throwOnChange);
    const currVal_64_0_0:boolean = !this.context.hasBookings;
    this._NgIf_64_6.check_ngIf(currVal_64_0_0,throwOnChange,false);
    this._NgIf_64_6.ngDoCheck(this,this._anchor_64,throwOnChange);
    const currVal_66_0_0:any = this.context.hasBookings;
    this._NgIf_66_6.check_ngIf(currVal_66_0_0,throwOnChange,false);
    this._NgIf_66_6.ngDoCheck(this,this._anchor_66,throwOnChange);
    this._vc_56.detectChangesInNestedViews(throwOnChange);
    this._vc_64.detectChangesInNestedViews(throwOnChange);
    this._vc_66.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_115:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('bookingList.TITLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_115,currVal_115))) {
      this.renderer.setText(this._text_15,currVal_115);
      this._expr_115 = currVal_115;
    }
    valUnwrapper.reset();
    const currVal_117:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('bookingList.EXPLANATION')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_117,currVal_117))) {
      this.renderer.setText(this._text_18,currVal_117);
      this._expr_117 = currVal_117;
    }
    valUnwrapper.reset();
    const currVal_119:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('common.LOADING')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_119,currVal_119))) {
      this.renderer.setElementProperty(this._el_23,'loading-text',currVal_119);
      this._expr_119 = currVal_119;
    }
    valUnwrapper.reset();
    const currVal_121:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_3.transform('bookingList.TOUR.NAME')),'\n                            ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_121,currVal_121))) {
      this.renderer.setText(this._text_26,currVal_121);
      this._expr_121 = currVal_121;
    }
    const currVal_123:any = import3.inlineInterpolate(1,'',this.context.selectedNavIndex,'');
    if (import3.checkBinding(throwOnChange,this._expr_123,currVal_123)) {
      this.renderer.setElementAttribute(this._el_44,'selected-nav',((currVal_123 == null)? (null as any): currVal_123.toString()));
      this._expr_123 = currVal_123;
    }
    valUnwrapper.reset();
    const currVal_124:any = import3.inlineInterpolate(2,'',valUnwrapper.unwrap(this._pipe_translate_4.transform('bookingList.NAV.TODAY')),' ',this.context.totalCount.TODAY,'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_124,currVal_124))) {
      this.renderer.setElementAttribute(this._el_46,'nav-title',((currVal_124 == null)? (null as any): currVal_124.toString()));
      this._expr_124 = currVal_124;
    }
    valUnwrapper.reset();
    const currVal_126:any = import3.inlineInterpolate(2,'',valUnwrapper.unwrap(this._pipe_translate_5.transform('bookingList.NAV.TOMORROW')),' ',this.context.totalCount.TOMORROW,'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_126,currVal_126))) {
      this.renderer.setElementAttribute(this._el_48,'nav-title',((currVal_126 == null)? (null as any): currVal_126.toString()));
      this._expr_126 = currVal_126;
    }
    valUnwrapper.reset();
    const currVal_128:any = import3.inlineInterpolate(2,'',valUnwrapper.unwrap(this._pipe_translate_6.transform('bookingList.NAV.ALL')),' ',this.context.totalCount.ALL,'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_128,currVal_128))) {
      this.renderer.setElementAttribute(this._el_50,'nav-title',((currVal_128 == null)? (null as any): currVal_128.toString()));
      this._expr_128 = currVal_128;
    }
    const currVal_130:boolean = !this.context.hideFiltered;
    if (import3.checkBinding(throwOnChange,this._expr_130,currVal_130)) {
      this.renderer.setElementProperty(this._el_52,'hidden',currVal_130);
      this._expr_130 = currVal_130;
    }
    valUnwrapper.reset();
    const currVal_131:any = import3.inlineInterpolate(2,'',valUnwrapper.unwrap(this._pipe_translate_7.transform('bookingList.NAV.FILTERED')),' ',this.context.totalCount.FILTERED,'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_131,currVal_131))) {
      this.renderer.setElementAttribute(this._el_52,'nav-title',((currVal_131 == null)? (null as any): currVal_131.toString()));
      this._expr_131 = currVal_131;
    }
    const currVal_133:any = import3.inlineInterpolate(1,'',this.context.modalClosable,'');
    if (import3.checkBinding(throwOnChange,this._expr_133,currVal_133)) {
      this.renderer.setElementAttribute(this._el_69,'closable',((currVal_133 == null)? (null as any): currVal_133.toString()));
      this._expr_133 = currVal_133;
    }
    valUnwrapper.reset();
    const currVal_134:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_8.transform('bookingModal.previous')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_134,currVal_134))) {
      this.renderer.setElementAttribute(this._el_69,'prev-text',((currVal_134 == null)? (null as any): currVal_134.toString()));
      this._expr_134 = currVal_134;
    }
    valUnwrapper.reset();
    const currVal_136:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_9.transform('bookingModal.next')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_136,currVal_136))) {
      this.renderer.setElementAttribute(this._el_69,'next-text',((currVal_136 == null)? (null as any): currVal_136.toString()));
      this._expr_136 = currVal_136;
    }
    valUnwrapper.reset();
    const currVal_138:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_10.transform('bookingModal.done')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_138,currVal_138))) {
      this.renderer.setElementAttribute(this._el_69,'last-text',((currVal_138 == null)? (null as any): currVal_138.toString()));
      this._expr_138 = currVal_138;
    }
    valUnwrapper.reset();
    const currVal_140:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_11.transform('bookingModal.step1.title')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_140,currVal_140))) {
      this.renderer.setElementProperty(this._el_71,'header',currVal_140);
      this._expr_140 = currVal_140;
    }
    valUnwrapper.reset();
    const currVal_142:any = import3.inlineInterpolate(3,'',valUnwrapper.unwrap(this._pipe_translate_12.transform('bookingModal.step1.description_1')),'[b]',valUnwrapper.unwrap(this._pipe_translate_13.transform('bookingModal.step1.description_2')),'[/b]',valUnwrapper.unwrap(this._pipe_translate_14.transform('bookingModal.step1.description_3')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_142,currVal_142))) {
      this.renderer.setElementProperty(this._el_71,'description',currVal_142);
      this._expr_142 = currVal_142;
    }
    valUnwrapper.reset();
    const currVal_146:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_15.transform('bookingModal.step2.title')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_146,currVal_146))) {
      this.renderer.setElementProperty(this._el_73,'header',currVal_146);
      this._expr_146 = currVal_146;
    }
    valUnwrapper.reset();
    const currVal_148:any = import3.inlineInterpolate(3,'',valUnwrapper.unwrap(this._pipe_translate_16.transform('bookingModal.step2.description_1')),'[b]',valUnwrapper.unwrap(this._pipe_translate_17.transform('bookingModal.step2.description_2')),'[/b]',valUnwrapper.unwrap(this._pipe_translate_18.transform('bookingModal.step2.description_3')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_148,currVal_148))) {
      this.renderer.setElementProperty(this._el_73,'description',currVal_148);
      this._expr_148 = currVal_148;
    }
    valUnwrapper.reset();
    const currVal_152:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_19.transform('bookingModal.step4.title')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_152,currVal_152))) {
      this.renderer.setElementProperty(this._el_75,'header',currVal_152);
      this._expr_152 = currVal_152;
    }
    valUnwrapper.reset();
    const currVal_154:any = import3.inlineInterpolate(3,'',valUnwrapper.unwrap(this._pipe_translate_20.transform('bookingModal.step4.description_1')),'[b]',valUnwrapper.unwrap(this._pipe_translate_21.transform('bookingModal.step4.description_2')),'[/b]',valUnwrapper.unwrap(this._pipe_translate_22.transform('bookingModal.step4.description_3')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_154,currVal_154))) {
      this.renderer.setElementProperty(this._el_75,'description',currVal_154);
      this._expr_154 = currVal_154;
    }
    valUnwrapper.reset();
    const currVal_158:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_23.transform('bookingList.TITLE_COMPANY')),'\n                            ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_158,currVal_158))) {
      this.renderer.setText(this._text_88,currVal_158);
      this._expr_158 = currVal_158;
    }
    this.compView_34.internalDetectChanges(throwOnChange);
    this.compView_61.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { this._BookingFilterComponent_34_5.context.ngAfterViewChecked(); }
  }
  destroyInternal():void {
    this._vc_56.destroyNestedViews();
    this._vc_64.destroyNestedViews();
    this._vc_66.destroyNestedViews();
    this.compView_34.destroy();
    this.compView_61.destroy();
    this._BookingFilterComponent_34_5.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
    this._pipe_translate_7.ngOnDestroy();
    this._pipe_translate_8.ngOnDestroy();
    this._pipe_translate_9.ngOnDestroy();
    this._pipe_translate_10.ngOnDestroy();
    this._pipe_translate_11.ngOnDestroy();
    this._pipe_translate_12.ngOnDestroy();
    this._pipe_translate_13.ngOnDestroy();
    this._pipe_translate_14.ngOnDestroy();
    this._pipe_translate_15.ngOnDestroy();
    this._pipe_translate_16.ngOnDestroy();
    this._pipe_translate_17.ngOnDestroy();
    this._pipe_translate_18.ngOnDestroy();
    this._pipe_translate_19.ngOnDestroy();
    this._pipe_translate_20.ngOnDestroy();
    this._pipe_translate_21.ngOnDestroy();
    this._pipe_translate_22.ngOnDestroy();
    this._pipe_translate_23.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 56)) { return new View_BookingComponent1(this.viewUtils,this,56,this._anchor_56,this._vc_56); }
    if ((nodeIndex == 64)) { return new View_BookingComponent2(this.viewUtils,this,64,this._anchor_64,this._vc_64); }
    if ((nodeIndex == 66)) { return new View_BookingComponent5(this.viewUtils,this,66,this._anchor_66,this._vc_66); }
    return (null as any);
  }
  handleEvent_23(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      this.context.showModalCoachmark();
      const pd_sub_0:any = ((<any>this.context.tour.show()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_34(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'filter')) {
      const pd_sub_0:any = ((<any>this.context.filterBookingList($event,false,true,true)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'pointsOfSale')) {
      const pd_sub_1:any = ((<any>this.context.getPointsOfSale($event)) !== false);
      result = (pd_sub_1 && result);
    }
    if ((eventName == 'autocompleteCompany')) {
      const pd_sub_2:any = ((<any>this.context.getAllCompanies($event)) !== false);
      result = (pd_sub_2 && result);
    }
    if ((eventName == 'autocompleteCities')) {
      const pd_sub_3:any = ((<any>this.context.getCitiesByName($event)) !== false);
      result = (pd_sub_3 && result);
    }
    return result;
  }
  handleEvent_44(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'subNavSelected')) {
      const pd_sub_0:any = ((<any>this.context.navSelection($event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_69(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'close')) {
      const pd_sub_0:any = ((<any>this.context.modalClose($event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'complete')) {
      const pd_sub_1:any = ((<any>this.context.modalCompleted($event)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
  handleEvent_71(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'next')) {
      const pd_sub_0:any = ((<any>this.context.modalGoNext($event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_73(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'prev')) {
      const pd_sub_0:any = ((<any>this.context.modalGoPrevious($event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'next')) {
      const pd_sub_1:any = ((<any>this.context.modalGoNext($event)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
  handleEvent_75(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'prev')) {
      const pd_sub_0:any = ((<any>this.context.modalGoPrevious($event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_85(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.showFiltersMobile($event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/booking/booking.component.ngfactory.ts